import { useMemo } from 'react';
import { formatDistanceToNowStrict } from 'date-fns';

import { formatterCurrencyTruncated } from '@/utilities/format';

import { Text, Grid } from '@simplywallst/ui-core';

import type { PriceTargetHistory } from '../../hooks/useCompanyPriceTargetHistory';

type PriceTargetTypes = PriceTargetHistory['priceTargetHistory'][number];

interface Props {
  priceTarget: PriceTargetTypes;
  updatedAt: PriceTargetTypes['fromDate'];
}
export const PriceTargetUpdatedFrom = ({ priceTarget, updatedAt }: Props) => {
  const timeSinceLastPriceTargetUpdate = useMemo(() => {
    if (!updatedAt) {
      return null;
    }
    return formatDistanceToNowStrict(new Date(updatedAt / 1000), {
      addSuffix: true,
    });
  }, [updatedAt]);
  return (
    <Grid alignItems="end">
      <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
        Updated {timeSinceLastPriceTargetUpdate} from{' '}
        <Text
          as="span"
          typography="tiny"
          color="whiteRGBA"
          opacity={0.5}
          data-cy-id="previous-price-target"
        >
          {
            priceTarget.currencyISO
              ? formatterCurrencyTruncated(
                  priceTarget.consensusMean,
                  priceTarget.currencyISO
                )
              : 'n/a' // Prefer no value rather than a value with an incorrect currencyISO
          }
        </Text>
      </Text>
    </Grid>
  );
};
